const fmt = new Intl.NumberFormat('en-GB');

function toWhole(n) {
  if (n === null || n === undefined || n === '') return null;
  const num = typeof n === 'number' ? n : Number(n);
  return Number.isFinite(num) ? Math.round(num) : null;
}

export function formatCredits(n) {
  const v = toWhole(n);
  if (v === null) return '';
  return `${fmt.format(v)} ${v === 1 ? 'credit' : 'credits'}`;
}

export function formatCreditRange(lo, hi) {
  const a = toWhole(lo);
  const b = toWhole(hi);
  if (a === null || b === null) return '';
  if (a === b) return formatCredits(a);
  return `${fmt.format(a)}–${fmt.format(b)} credits`;
}

export function shouldShowBalance(tier) {
  if (typeof tier !== 'string') return false;
  const t = tier.toUpperCase();
  return t === 'PAYG' || t === 'TEAM';
}
